import React from 'react';
import styles from './ArticleCarouselCard.module.scss'; // Custom styles for the card

export interface ArticleCarouselCardProps {
    imageSrc: string;
    translation: Function;
    categoryColor: string;
    label: string;
    title: string;
    date: string;
    redirectUrl: string;
    views?: number;
}

const handleRedirect = (link: string) => {
    window.open(link, '_blank');
}
//to handle some url with symbol "(" ")" in it. Background image cant bing image url like this.
const escapeCSSUrl = (url: string) => url.replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');

const ArticleCarouselCard: React.FC<ArticleCarouselCardProps> = ({ imageSrc, translation, label, title, date, views, categoryColor, redirectUrl }) => (
    <div className={styles.card} onClick={() => handleRedirect(redirectUrl)}>
        <div className={styles.imageContainer}
            style={{ backgroundImage: `url(${escapeCSSUrl(imageSrc)})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
        </div>
        <div className={styles.details}>
            {/* <span className={styles.label}>{label}</span> */}
            <span
                className={`${styles.label} ${styles[categoryColor] || styles.default}`}
            >
                {label}
            </span>
            <h3 className={styles.title}>{title}</h3>
            <div className={styles.footer}>
                <span className={styles.date}>
                    <i className="fa fa-calendar" aria-hidden="true"></i> {date}
                </span>
                {views && <span className={styles.views}>
                    <i className="fa fa-eye" aria-hidden="true"></i>{`${views} ${translation('dashboard.home.label.views')}`}
                </span>}
            </div>
        </div>
    </div>
);

export default ArticleCarouselCard;